<form #theForm="ngForm" name="newFormatType" (ngSubmit)="ok()" [formGroup]="formData" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">New error category</h4>
        <button type="button" class="close" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="form-group modal-body">
        <div class="container-fluid">

            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Name</label>
                        <input formControlName="name" class="form-control" ngbAutofocus required />
                        <div [class.invisible]="!formData.get('name').hasError('required') || formData.get('name').untouched"
                            class="error">
                            <span>Required</span>
                        </div>
                    </div>
                </div>

                <div class="col-md-8">
                    <div class="form-group">
                        <label>Description</label>
                        <input formControlName="description" class="form-control" required />
                        <div [class.invisible]="!formData.get('description').hasError('required') || formData.get('description').untouched"
                            class="error">
                            <span>Required</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="modal-footer">
        <div class="text-center">
            <button type="submit" style="min-width: 12rem;" class="btn btn-primary"
                [disabled]="formData.invalid">OK</button>
            <button type="button" style="min-width: 12rem;" class="btn btn-default" (click)="cancel()">Cancel</button>
        </div>
    </div>
</form>
